exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js?sourceMap!./node_modules/extract-text-webpack-plugin/dist/loader.js??ref--12-0!./node_modules/vue-style-loader!./node_modules/css-loader??ref--12-2!./node_modules/postcss-loader/lib??ref--12-3!./node_modules/sass-loader/dist/cjs.js??ref--12-4!./src/sass/style.scss
// module id = InrL
// module chunks = 1